import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, SelectChangeEvent, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { StyledLanguageSelect, StyledMenuItem } from './LanguageDropdown.styles';

function LanguageDropdown() {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const changeLanguage = (event: SelectChangeEvent<string>) => {
    i18n.changeLanguage(event.target.value as string);
  };

  return (
    <StyledLanguageSelect 
      value={i18n.language} 
      onChange={changeLanguage}
      variant="outlined"
      IconComponent={KeyboardArrowDownIcon}
      size='small'
    >
      <StyledMenuItem value="en" $color={theme.palette.black.main}>EN</StyledMenuItem>
      <StyledMenuItem value="pl" $color={theme.palette.black.main}>PL</StyledMenuItem>
    </StyledLanguageSelect>
  );
}

export default LanguageDropdown;
